import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DispatchTaskDetails } from '../classes/dispatch-task-details';

const INBOUND_TASK_TYPE = 'InboundFlight';

@Pipe({
  standalone: false,
  name: 'taskDetailsOooi'
})
export class TaskDetailsOooiPipe implements PipeTransform {
  constructor(readonly datePipe: DatePipe) {}

  transform(taskDetails: DispatchTaskDetails, type: 'TASK' | 'STA_STD' | 'ETA_ETD' | 'ON_OUT' | 'IN_OFF'): string {
    let dateTimeVal: any;

    if (taskDetails) {
      const isInbound = taskDetails.taskTypeName === INBOUND_TASK_TYPE;
      const metadata = taskDetails.metadata;
      switch (type) {
        case 'TASK':
          if (taskDetails.plannedEndTime) {
            dateTimeVal = taskDetails.plannedEndTime;
          }
          break;
        case 'STA_STD':
          if (metadata) {
            if (isInbound && metadata.scheduledArrivalTime) {
              dateTimeVal = metadata.scheduledArrivalTime;
            } else if (!isInbound && metadata.scheduledDepartureTime) {
              dateTimeVal = metadata.scheduledDepartureTime;
            }
          }
          break;
        case 'ETA_ETD':
          if (metadata) {
            if (isInbound && metadata.estimatedArrivalTime) {
              dateTimeVal = metadata.estimatedArrivalTime;
            } else if (!isInbound && metadata.estimatedDepartureTime) {
              dateTimeVal = metadata.estimatedDepartureTime;
            }
          }
          break;
        case 'ON_OUT':
          if (metadata) {
            if (isInbound && metadata.actualOnTime) {
              dateTimeVal = metadata.actualOnTime;
            } else if (!isInbound && metadata.actualOutTime) {
              dateTimeVal = metadata.actualOutTime;
            }
          }
          break;
        case 'IN_OFF':
          if (metadata) {
            if (isInbound && metadata.actualInTime) {
              dateTimeVal = metadata.actualInTime;
            } else if (!isInbound && metadata.actualOffTime) {
              dateTimeVal = metadata.actualOffTime;
            }
          }
          break;
      }
    }
    return dateTimeVal ? this.datePipe.transform(this.toDate(dateTimeVal), 'HH:mm') : '--';
  }

  /**
   * Converts a value to a Date object. Handles arrays returned by the backend
   * (e.g. [2026,2,11,8,7,0,0] from Joda LocalDateTime serialization)
   * as well as standard date strings.
   */
  private toDate(value: any): Date | string {
    if (Array.isArray(value)) {
      // Array format: [year, month, day, hour, minute, second, millisecond]
      // Note: JavaScript months are 0-based, but backend sends 1-based months
      const [year, month, day, hour = 0, minute = 0, second = 0, ms = 0] = value;
      return new Date(year, month - 1, day, hour, minute, second, ms);
    }
    return value;
  }
}
